// import 'blaze-slider/dist/blaze.css'

import BlazeSlider from '../../../lib/blaze-slider/blaze-slider'

export const infiniCaroussel = () => {
  const newsSliders = document.querySelectorAll('.blaze-slider')
  if (newsSliders?.length) {
    newsSliders.forEach((slider) => {
      const newsBlazeSlider = new BlazeSlider(slider, {
        all: {
          slidesToShow: 1,
          draggable: false,
          slideGap: '0',
          transitionDuration: 200
        }
      })

      const slideEvent = newsBlazeSlider.onSlide((pagei, firstVisibleSlidei, lastVisibleSlidei) => {
        const Sliders = slider.querySelectorAll('.carousel__slide-list .carousel__slide-item')
        console.log('sliders', Sliders)
        slider.querySelector('.carousel__slide-list .carousel__slide-item.active').classList.remove('active')
        Sliders[2].classList.add('active')
      })

      // mettre la class active sur le 3 élément du carousel
      // if (newsSliders) {
      const Slides = slider.querySelectorAll('.carousel__slide-list .carousel__slide-item')
      Slides[2].classList.add('active')
      // }
    })

    const showMoreMobiles = document.querySelectorAll('.home_news .wrapper_page.only_mobile_tablet .btn_container .btn')

    if (showMoreMobiles?.length) {
      showMoreMobiles.forEach((showMoreMobile) => {
        showMoreMobile.addEventListener('click', () => {
          const hiddenItems = showMoreMobile.closest('.wrapper_page.only_mobile_tablet').querySelectorAll('.hide-item')
          for (let i = 0; i < 3; i++) {
            if (hiddenItems[i]) {
              hiddenItems[i].classList.add('show-item')
              hiddenItems[i].classList.remove('hide-item')
            }
            if (!hiddenItems[i + 1]) {
              showMoreMobile.classList.add('hide')
            }
          }
        })
      })
    }
  }
}
